<ul class="ion-no-margin">
  <li>
    <hohr-button
      [routerLink]="['/create']"
      [label]="'shared.header.create_cv' | translate | uppercase"
      [color]="(router.url | routeCheck : 'ccv') ? 'primary' : 'secondary'"
      fill="clear"
      expand="full"
      (action)="close()"
    ></hohr-button>
  </li>

  <li *ngIf="!authenticated">
    <hohr-button
      [label]="'shared.header.login' | translate | uppercase"
      color="secondary"
      fill="clear"
      expand="full"
      (action)="authSandbox.login(); close()"
    ></hohr-button>
  </li>
</ul>
<ng-container *ngIf="authenticated">
  <div class="divider"></div>
  <hohr-menu
    [username]="username"
    [href]="myprofileURI"
    [translations]="translations"
  ></hohr-menu>
</ng-container>
